import { RemoteCitizensService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const citizensService = new RemoteCitizensService(httpClient)

export { citizensService }
